import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useMemo, useCallback, useState } from 'react';
import Input from '../input/Input';
import * as styles from './RangeField.style';
export function RangeField(_ref) {
  let {
    name,
    dataRef = 'range-field',
    forwardedRef,
    icon,
    disabled,
    loading,
    value,
    error,
    placeholder,
    maxVisibleSuggestions = 6,
    onChange,
    onBlur,
    onFocus,
    printValue,
    suggestions,
    style = {
      input: {},
      suggestions: {}
    },
    printSuggestion,
    onSuggestionSelected,
    onSuggestionsVisibilityChange,
    ...rest
  } = _ref;
  const [suggestionsVisibility, setSuggestionsVisibility] = useState(false);
  const [isMouseOverSuggestions, setIsMouseOverSuggestions] = useState(false);
  const [formattedValue, setFormattedValue] = useState();
  const getFormattedValue = useCallback(inputValue => {
    if (printValue && inputValue) {
      return printValue(inputValue);
    }
    return inputValue;
  }, [printValue]);
  useEffect(() => {
    const tempFormattedValue = getFormattedValue(value);
    if (tempFormattedValue !== formattedValue) {
      setFormattedValue(getFormattedValue(value));
    }
  }, [formattedValue, getFormattedValue, value]);
  const onInternalChange = useCallback(e => {
    const numericMatch = e.target.value.match(/\d+/g);
    e.target.value = numericMatch ? numericMatch.join('') : '';
    e.target.name = name || '';
    if (onChange) {
      onChange(e);
    }
  }, [name, onChange]);
  const toggleSuggestions = useCallback(visibility => {
    if (suggestions && suggestions.length > 0) {
      setSuggestionsVisibility(visibility);
      if (onSuggestionsVisibilityChange) {
        onSuggestionsVisibilityChange(visibility);
      }
    }
  }, [onSuggestionsVisibilityChange, suggestions]);
  const onInternalBlur = useCallback(e => {
    if (!isMouseOverSuggestions) {
      toggleSuggestions(false);
    }
    if (name) {
      e.target.name = name;
    }
    if (onBlur) {
      onBlur(e);
    }
  }, [isMouseOverSuggestions, name, onBlur, toggleSuggestions]);
  const onInternalFocus = useCallback(e => {
    toggleSuggestions(true);
    if (onFocus) {
      onFocus(e);
    }
  }, [onFocus, toggleSuggestions]);
  const onInternalSuggestionSelected = useCallback(suggestion => () => {
    setIsMouseOverSuggestions(false);
    toggleSuggestions(false);
    if (onSuggestionSelected) {
      onSuggestionSelected(suggestion);
    }
  }, [onSuggestionSelected, toggleSuggestions]);
  const onInternalSuggestionsMouseEnter = useCallback(() => {
    setIsMouseOverSuggestions(true);
  }, []);
  const onInternalSuggestionsMouseLeave = useCallback(() => {
    setIsMouseOverSuggestions(false);
    toggleSuggestions(false);
  }, [toggleSuggestions]);
  const inputStyle = useMemo(() => ({
    borderRadius: suggestionsVisibility ? '.3rem .3rem 0 0' : 'inherited',
    ...style?.input
  }), [suggestionsVisibility, style?.input]);
  const keyPressHandler = useCallback(event => {
    if (event.key === 'Enter') {
      setIsMouseOverSuggestions(false);
      toggleSuggestions(false);
    }
  }, [toggleSuggestions]);
  const getSuggestionLabel = useCallback(suggestion => printSuggestion ? printSuggestion(suggestion) : JSON.stringify(suggestion), [printSuggestion]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.basic
  }, /*#__PURE__*/React.createElement(Input, _extends({
    dataRef: dataRef,
    ref: forwardedRef,
    type: "tel",
    pattern: "[0-9]*",
    value: formattedValue || '',
    onChange: onInternalChange,
    onBlur: onInternalBlur,
    onFocus: onInternalFocus,
    icon: icon,
    error: error,
    loading: loading,
    disabled: disabled,
    autocomplete: "off" // Still not working on Chrome
    ,
    placeholder: placeholder,
    style: inputStyle,
    min: 0,
    onKeyPress: keyPressHandler
  }, rest)), /*#__PURE__*/React.createElement(Input, _extends({
    type: "hidden",
    name: name,
    dataRef: `${dataRef}-hidden`,
    value: value,
    onChange: () => {}
  }, rest)), suggestionsVisibility && suggestions && suggestions.length > 0 && /*#__PURE__*/React.createElement(_StyledDiv2, {
    "data-ref": `${dataRef}-suggestions`,
    style: style?.suggestions,
    onMouseEnter: onInternalSuggestionsMouseEnter,
    onMouseLeave: onInternalSuggestionsMouseLeave,
    $_css2: styles.suggestions
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $maxVisibleSuggestions: maxVisibleSuggestions,
    $_css3: styles.suggestionsScroller
  }, suggestions.map(suggestion => /*#__PURE__*/React.createElement(_StyledDiv4, {
    role: "button",
    "data-ref": `${dataRef}-suggestion`,
    key: `${dataRef}-suggestions-${getSuggestionLabel(suggestion)}`,
    onClick: onInternalSuggestionSelected(suggestion),
    $_css4: styles.suggestion
  }, getSuggestionLabel(suggestion))))));
}
export default RangeField;
var _StyledDiv = _styled("div").withConfig({
  displayName: "RangeField___StyledDiv",
  componentId: "sc-wwdq0l-0"
})(["", ""], p => p.$_css);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "RangeField___StyledDiv2",
  componentId: "sc-wwdq0l-1"
})(["", ""], p => p.$_css2);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "RangeField___StyledDiv3",
  componentId: "sc-wwdq0l-2"
})(["", ""], p => p.$_css3);
var _StyledDiv4 = _styled("div").withConfig({
  displayName: "RangeField___StyledDiv4",
  componentId: "sc-wwdq0l-3"
})(["", ""], p => p.$_css4);
//# sourceMappingURL=RangeField.js.map